export const removeDuplicates = (arrayWithDuplicates: any[]) => {
  return arrayWithDuplicates.filter((element, index) => {
    return arrayWithDuplicates.indexOf(element) === index;
  });
};
